export class StringUtils {
  public static GetFileExtension(base64String: string) {
      const data = base64String.substring(0, 5);
      switch (data.toLocaleUpperCase()) {
          case "IVBOR":
              return "png";
          case "/9J/4":
              return "jpg";
          case "AAAAF":
              return "mp4";
          case "JVBER":
              return "pdf";
          case "AAABA":
              return "ico";
          case "UMFYI":
              return "rar";
          case "E1XYD":
              return "rtf";
          case "U1PKC":
              return "txt";
          case "MQOWM":
          case "77U/M":
              return "srt";
          case "UESDB":
            return "docx";
          default:
              return "";
      }
  }

  public static PrepareFileToDownload(base64: string) : {file: string, extension: string} {
    const fileType = this.GetFileExtension(base64);
    return {
      file: `data:application/${fileType};base64,` + base64,
      extension: fileType
    }
  }
}
